import { render } from "./FooterBar.vue?vue&type=template&id=44c04e12&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=44c04e12&scoped=true&lang=scss"

import exportComponent from "E:\\web-workspace\\xiaomodou-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c04e12"]])

export default __exports__